import { FC, ReactNode } from 'react';

import { Box, Flex, FlexProps } from '@chakra-ui/react';

interface CardButtonProps extends Omit<FlexProps, 'title'> {
  label: ReactNode;
  text?: ReactNode;
  onClick: () => void;
}

const CardButton: FC<CardButtonProps> = ({ text, label, onClick, ...props }) => {
  return (
    <Flex
      {...props}
      flexDirection="column"
      borderRadius="8px"
      p="10px 12px"
      h="130px"
      border="1px solid #464646"
      onClick={onClick}
      backgroundColor="#313131"
      justifyContent="space-between"
      transition="all 0.2s ease-in-out"
      cursor="pointer"
      _active={{
        borderColor: '#8b8b8b',
      }}
    >
      <Box
        fontSize="13px"
        lineHeight="1.2"
        textTransform="uppercase"
        fontFamily="Special Gothic Expanded One"
        color="#FFFFFF"
      >
        {label}
      </Box>
      {props.children && props.children}
      {text && (
        <Box fontSize="12px" fontWeight="600" lineHeight="1.2" color="#FFFFFFCC">
          {text}
        </Box>
      )}
    </Flex>
  );
};

export default CardButton;
